<div class="setting-section">
  <app-machine-mngt-detail [customers]="customers" [machines]="dataSource.data" (machineSaved)="onMachineSaved($event)"></app-machine-mngt-detail>

  <div class="fc-mngt-toolbar">
    <h2 class="fc-mngt-title">Machines</h2>
    <div class="fc-mngt-search">
      <span class="material-icons fc-mngt-search-icon">search</span>
      <input class="fc-mngt-search-input" type="text" placeholder="Filter machines…" (keyup)="doFilter($any($event.target).value)" />
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" class="machinesTable" matSort>
    <ng-container matColumnDef="serialNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Serial Number</th>
      <td mat-cell *matCellDef="let element">{{ element.serialNumber }}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="operator">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Operator</th>
      <td mat-cell *matCellDef="let element">{{ element.operator }}</td>
    </ng-container>
    <ng-container matColumnDef="customer">
      <th mat-header-cell *matHeaderCellDef>Customer</th>
      <td mat-cell *matCellDef="let element">{{ element.customerName }}</td>
    </ng-container>
    <ng-container matColumnDef="function">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Function</th>
      <td mat-cell *matCellDef="let element">{{ functonLabel[element.function] }}</td>
    </ng-container>
    <ng-container matColumnDef="year">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Year</th>
      <td mat-cell *matCellDef="let element">{{ element.year }}</td>
    </ng-container>
    <ng-container matColumnDef="machineType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let element">{{ element.machineType }}</td>
    </ng-container>
    <ng-container matColumnDef="hasImage">
      <th mat-header-cell *matHeaderCellDef>Image</th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.hasImage" class="fc-action-btn" (click)="viewImgDialog(element.id)">View</button>
      </td>
    </ng-container>
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="actionButtonCol">
        <button class="fc-action-btn" (click)="edit(element)">Edit</button>
        <button class="fc-action-btn fc-action-btn--danger" (click)="deleteConfirmDialog(element)">Delete</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell fc-no-data" colspan="9">No machines found</td>
    </tr>
  </table>
</div>
